export default __webpack_public_path__ + "static/media/file-image.2fe1abcc.svg";